import { db } from '../../common/config/Firebase';
import moment from 'moment';

/**
 * Adds a new time record (entrada/salida) to Firestore
 * @param {Object} recordData - The time record data
 * @param {string} recordData.employeeId - Employee ID
 * @param {string} recordData.actionType - 'entrada' or 'salida'
 * @param {Object} recordData.location - Location object with address, lat, lng
 * @param {string} recordData.timestamp - Date of the record
 * @param {string} recordData.authMethod - 'rfid' or 'manual'
 * @param {string} recordData.notes - Optional notes
 * @returns {Promise<string>} - The created record ID
 */
export const addTimeRecordUseCase = async (recordData) => {
    try {
        const timestamp = recordData.timestamp || Date.now();
        const date = moment(timestamp);
        const year = date.format('YYYY');
        const month = date.format('MM');

        const record = {
            employeeId: recordData.employeeId,
            timestamp,
            actionType: recordData.actionType,
            location: recordData.location || null,
            authMethod: recordData.authMethod || 'manual',
            deviceInfo: navigator.userAgent,
            createdAt: timestamp,
            modifiedAt: null,
            modifiedBy: null,
            notes: recordData.notes || '',
            manualCorrection: recordData.authMethod === 'manual'
        };

        const docRef = await db
            .collection('timeRecords')
            .doc(recordData.employeeId)
            .collection(year)
            .doc(month)
            .collection('records')
            .add(record);

        console.log('Time record created with ID:', docRef.id);
        return docRef.id;
    } catch (error) {
        console.error('Error adding time record:', error);
        throw error;
    }
};
